import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { BrowserRouter as Router } from "react-router-dom";
import { CustomProvider as RSsuiteProvider } from "rsuite";
import { SITE_TITLE } from "constants/site.constants";
import { useAppSelector } from "../store/hooks";
import { getColorTheme } from "../store/slices/userSessionSlice";

/**
 * Sets providers for app
 * @param param0
 * @returns
 */
export default function AppProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  // get current theme value from store
  const theme = useAppSelector(getColorTheme);

  return (
    <HelmetProvider>
      <Helmet defaultTitle={SITE_TITLE} />
      <div data-theme={theme}>
        <RSsuiteProvider theme={theme}>
          <Router
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            {children}
          </Router>
        </RSsuiteProvider>
      </div>
    </HelmetProvider>
  );
}
